import { z } from 'zod';

export const webEnvSchema = z.object({
  VITE_API_URL: z.string().url(),
  // Which country this build serves. NO default — a missing value must fail the
  // prod build (see vite.config.ts), never silently ship UZ under another domain.
  VITE_COUNTRY: z.enum(['uz', 'kz', 'es', 'cl']),
  // Telegram bot username (no @) for the Login Widget. Unset → button hidden.
  VITE_TELEGRAM_BOT_USERNAME: z.string().optional(),
  // PostHog project API key (optional). Unset → PostHog stays dormant (no SDK
  // loaded, no capture). Set to enable autocapture + session replay.
  VITE_POSTHOG_KEY: z.string().optional(),
  // PostHog ingestion host (optional). Defaults to EU cloud in lib/posthog.ts
  // when unset — pick the region matching the project you create.
  VITE_POSTHOG_HOST: z.string().url().optional(),
  // Stripe PUBLISHABLE key (`pk_live_…`, public by design) for the card form on
  // our own site — a Stripe deployment only (Spain; Kazakhstan's CI names it
  // VITE_STRIPE_KZ_PK). Unset → the hosted Stripe Checkout runs as before.
  // Read through `lib/stripe-elements.ts`, which also refuses anything that is
  // not a `pk_` key.
  VITE_STRIPE_PUBLISHABLE_KEY: z.string().optional(),
  VITE_STRIPE_KZ_PK: z.string().optional(),
});

export type WebEnv = z.infer<typeof webEnvSchema>;

export function parseWebEnv(meta: ImportMetaEnv): WebEnv {
  return webEnvSchema.parse({
    VITE_API_URL: meta.VITE_API_URL,
    VITE_COUNTRY: meta.VITE_COUNTRY,
    VITE_TELEGRAM_BOT_USERNAME: meta.VITE_TELEGRAM_BOT_USERNAME,
    VITE_POSTHOG_KEY: meta.VITE_POSTHOG_KEY,
    VITE_POSTHOG_HOST: meta.VITE_POSTHOG_HOST,
    VITE_STRIPE_PUBLISHABLE_KEY: meta.VITE_STRIPE_PUBLISHABLE_KEY,
    VITE_STRIPE_KZ_PK: meta.VITE_STRIPE_KZ_PK,
  });
}
